/*eslint-disable*/
export const REGEX_NAME =
  '^(?:[а-яёА-ЯЁ]+)(?:[\-\s]{0,2})?(?:[а-яёА-ЯЁ]+)?$|^(?:[a-zA-Z]+)(?:[\-\s]{0,2})?(?:[a-zA-Z]+)?$';
export const REGEX_PHONE = '^\+?(7|8)?\d{10}$';

export const BIG_WIDTH_SIZE = 1280;
export const MIDDLE_WIDTH_SIZE = 769;
export const MOBILE_WIDTH_SIZE = 320;

export const BIG_WIDTH_SIZE_COLUMNS = 999;
export const MIDDLE_WIDTH_SIZE_COLUMNS = 588;

export const BIG_WIDTH_SIZE_FEEDBACKS = 6;
export const MIDDLE_WIDTH_SIZE_FEEDBACKS = 4;
export const MOBILE_WIDTH_SIZE_FEEDBACKS = 2;
